import React from 'react';

import StatusPanel from '../StatusPanel';

interface IToolkitImportProps {
  visible: boolean;
  loading?: boolean;
  onClose?: () => void;
}

const ToolkitImport: React.FC<IToolkitImportProps> = ({ visible, loading, onClose }) => {
  return (
    <StatusPanel.LoadingPanel group="Toolkits: ELMA365: Import" loading={loading} visible={visible} onClose={onClose} />
  );
};

export default ToolkitImport;
